/* eslint-disable no-unused-vars */
import $ from "jquery";

export default class PottsalatMisc {
    constructor() {
        $(".woocommerce-cart-form__cart-item .product-quantity .plus").click(
            function () {
                let val = parseInt($(this).parent().find("input").val());
                $(this)
                    .parent()
                    .find("input")
                    .val(val + 1);
            }
        );

        $(
            ".page-template-template-fullwidth-php .cart-collaterals .cross-sells"
        )
            .detach()
            .insertAfter(
                $(
                    ".page-template-template-fullwidth-php .cart-collaterals .cart_totals"
                )
            )
            .css({ display: "block" });

        function toggleFooterMenu() {
            $(".footer-handheld-menu").toggleClass("active");
        }

        $(".toggle-footer-menu, .footer-handheld-menu .menu-toggle").click(
            toggleFooterMenu
        );

        // Dont go initialisation.
        this.dontGo({
            title: "Dein Salat wird schlecht…..",
            timeout: 2000,
            faviconSrc:
                "/wp-content/plugins/pottsalat/static/images/crying-face.ico",
        });

        function isMobile() {
            return window.innerWidth <= 767;
        }

        function decreaseQty() {
            let input = $(this).next().find("input");
            let value = input.val();
            let min = input.attr("min");

            if (value > min) {
                value--;
                input.val(value).change();
                $('input[name="update_cart"]').click();
            }

            if (value <= min) {
                input.val(min).change();
            }
        }

        $(".woocommerce-cart").on(
            "click",
            "table.cart td.product-quantity .minus",
            decreaseQty
        );

        function increaseQty() {
            let input = $(this).prev().find("input");
            let value = parseInt(input.val());
            let max = parseInt(input.attr("max"));

            if (value < max) {
                value++;
                input.val(value).change();
                $('input[name="update_cart"]').click();
            }

            if (value >= max) {
                input.val(max).change();
            }
        }

        $(".woocommerce-cart").on(
            "click",
            "table.cart td.product-quantity .plus",
            increaseQty
        );

        function headerBar() {
            let headerBar = $("#header-bar");
            let headerBarHeight = headerBar.outerHeight();
            let spacer = $('<div class="header-bar-spacer"></div>').prependTo(
                "body"
            );
            spacer.css("height", headerBarHeight);
        }

        headerBar();

        let handheldPopoverMenu = $(".navigation-handheld-popover");

        $(".pottsalat-menu-open").on("click", () => {
            handheldPopoverMenu.addClass("active");
            $("html").addClass("locked-body");
        });

        $(".pottsalat-menu-close").on("click", () => {
            handheldPopoverMenu.removeClass("active");
            $("html").removeClass("locked-body");
        });

        $(".pottsalat-expandable-menu-item").on("click", function () {
            $(this)
                .parent()
                .find(".handheld-menu-sub-navigation")
                .addClass("active");
        });

        $(".handheld-menu-sub-navigation .back-button").on(
            "click",
            function () {
                $(this).parent().parent().removeClass("active");
            }
        );
    }

    dontGo() {
        let options =
            arguments.length > 0 && arguments[0] !== undefined
                ? arguments[0]
                : {};

        let defaults = {
            title: "Don't go!",
            faviconSrc: "",
            timeout: 0,
            interval: 1000,
        };

        let opts = Object.assign(defaults, options);
        let originalTitle = document.title;
        let favicon = void 0;
        let originalFavicon = void 0;
        let img = void 0;
        let timeout = void 0;
        let interval = void 0;
        let counter = 0;

        // Store the original favicon if it exists
        if (document.querySelectorAll('link[rel$="icon"]').length) {
            favicon = document.querySelector('link[rel$="icon"]');
            originalFavicon = favicon.getAttribute("href");
        }

        // Preload the alternative favicon
        if (opts.faviconSrc.length) {
            img = new Image(); // eslint-disable-line
            img.src = opts.faviconSrc;
        }

        let setHidden = function setHidden() {
            // if title is string just switch the title
            if (typeof opts.title === "string") {
                document.title = opts.title;
            } else {
                document.title = opts.title[0];
                interval = setInterval(nextTitle, opts.interval);
            }

            if (opts.faviconSrc.length) {
                favicon.setAttribute("href", opts.faviconSrc);
            }
        };

        let nextTitle = function nextTitle() {
            counter++;
            if (counter >= opts.title.length) {
                counter = 0;
            }
            document.title = opts.title[counter];
        };

        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden") {
                if (opts.timeout > 0) {
                    timeout = setTimeout(setHidden, opts.timeout);
                } else {
                    setHidden();
                }
            } else {
                document.title = originalTitle;
                favicon.setAttribute("href", originalFavicon);
                clearTimeout(timeout);
                clearInterval(interval);
            }
        });
    }
}
